<div class="flex gap-4">
  <div>
    <label class="lum-label filter-label">Channel</label>
    <input
      type="text"
      class="lum-input"
      lumDebounceTime
      [debounceTime]="500"
      (debounceValue)="onFilterChange($event, 'label')"
    />
  </div>
  <div *ngIf="isShowFilterStatus">
    <label class="lum-label filter-label">Status</label>
    <mat-select
      [(value)]="currentQueryParams['status']"
      (selectionChange)="onFilterChange($event.value, 'status')"
      class="lum-select"
    >
      <mat-option [value]="''">All</mat-option>
      <mat-option [value]="'0'">Inactive</mat-option>
      <mat-option [value]="'1'">Active</mat-option>
    </mat-select>
  </div>
  <div *ngIf="isShowFilterTags">
    <lum-filter-tag
      [value]=""
      [inlineChips]="true"
      (onFilterSelect)="onSelectTag($event)"
    ></lum-filter-tag>
  </div>

  <div class="pt-8">
    <button class="button lum-button" [matMenuTriggerFor]="menu">
      + Add Filter
    </button>
    <mat-menu #menu="matMenu">
      <ng-container *ngFor="let filter of filterOptions; trackBy: trackByValue">
        <button mat-menu-item (click)="$event.stopPropagation()">
          <mat-checkbox [(ngModel)]="filter.checked" [disabled]="filter.disabled">{{
            filter.label
          }}</mat-checkbox>
        </button>
      </ng-container>
    </mat-menu>
  </div>
</div>
